import { render, staticRenderFns } from "./CalendarLinks.vue?vue&type=template&id=1d3e83a4"
import script from "./CalendarLinks.vue?vue&type=script&lang=js"
export * from "./CalendarLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports